(function (w, d, s, c, t, a, m) {
  w[t] =
    w[t] ||
    function () {
      (w[t].q = w[t].q || []).push(arguments);
    };
  w[t].l = 1 * new Date();
  a = d.createElement(s);
  m = d.getElementsByTagName(s)[0];
  a.async = 1;
  a.src = c;
  m.parentNode.insertBefore(a, m);
})(globalThis, document, "script", "https://a.wb.ru/sdk/sdk.js", "wba");

wba("init", { counterId: __WBA_COUNTER_ID__ ? Number(__WBA_COUNTER_ID__) : 987 });
wba("pageview");
